import { useDispatch, useSelector } from "react-redux";
import {
  applyConditions,
  discardCondition,
  selectCostType,
  selectCurrentTab,
  selectEditingStatus,
  selectGeneralConditions,
  selectIdxConditions,
  selectLoading,
  selectSelectedVendor,
  selectVendorConditions,
  tabChange,
} from "../../../../redux/features/configuration/parts/vendorCostSlice";
import { ConditionsMenu } from "./ConditionsMenu";
import { useEffect, useMemo, useRef, useState } from "react";
import DeletePartDialog from "./DeletePartDialog";
import { Popover, Skeleton } from "@mui/material";
import { DialogTrigger } from "../../../../components/Dialog/Dialog";
import { VendorTabContent } from "./VendorTabcontent";
import { deleteTatInfo } from "../../services/SupplyChainService";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { useSnackBar } from "../../../../hooks/useSnackBar";

const conditionProp = {
  C: "partConditionId",
  R: "repairTypeId",
};

export const VendorTabs = ({ part, vendorTempId }) => {
  const partConditions = useSelector(selectGeneralConditions);
  const costType = useSelector(selectCostType);
  // const selectedVendor = useSelector(selectSelectedVendor);
  const vendorConditionsSelector = useSelector((state) =>
    selectVendorConditions(state, vendorTempId)
  );
  const vendorConditions = useMemo(
    () => vendorConditionsSelector ?? [],
    [vendorConditionsSelector]
  );
  const tab = useSelector(selectCurrentTab);
  const idxConditions = useSelector(selectIdxConditions);
  const [disabledNav, setDisabledNav] = useState({ left: true, right: false });
  const [anchorEl, setAnchorEl] = useState(null);
  const tabsContainerRef = useRef(null);
  const tabsCount = vendorConditions.length;
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const editing = useSelector(selectEditingStatus);
  const { successMsg } = useSnackBar();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = (direction) => {
    scrollToNextElement(tabsContainerRef.current, direction);
  };

  const applyClick = (e) => {
    //TODO: actually delete condition)
    dispatch(
      applyConditions({
        deleteConditions: Array.from(e.deleteConditions),
        newConditions: Array.from(e.newConditions),
        vendorTempId,
        costType,
      })
    );
  };

  const handleScroll = (e) => {
    let maxLeft = e.target.scrollWidth - e.target.clientWidth;
    setDisabledNav({
      left: e.target.scrollLeft < 1,
      right: e.target.scrollLeft >= maxLeft - 3,
    });
  };

  useEffect(() => {
    // setTabSelection(new Set(vendorConditions.map(c => costType === "C" ? c.partConditionId : c.repairTypeId)));
    // setIdxVConditions(Object.fromEntries(vendorConditions.map(vC => [costType === "C" ? c.partConditionId : c.repairTypeId, vC])));
  }, [vendorConditions]);

  useEffect(() => {
    if (tab) {
      document
        .getElementById(`tab/${vendorTempId}/${tab.id}`)
        ?.scrollIntoView({ behavior: "smooth" });
    }
  }, [tab]);

  const deleteVendorCondition = (tatId) => {
    deleteTatInfo(tatId).then((response) => {
      if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
        dispatch(discardCondition({ vendorTempId, conditionId: tatId }));
        successMsg(`${costType === "C" ? "Condition" : "Repair type"} deleted`);
      }
    });
  };

  const handleDeleteTab = (e, conditionId) => {
    e.stopPropagation();
    dispatch(discardCondition({ vendorTempId, partConditionId: conditionId }));
  };

  const selectTab = (t) => {
    dispatch(tabChange(t));
  };

  const memoVendorConditions = useMemo(() => {
    return vendorConditions.map((c) =>
      costType === "C" ? c.partConditionId : c.repairTypeId
    );
  }, [vendorConditions]);

  return (
    <div className="vendor-tabs-component">
      {/* {JSON.stringify(vendorConditions)} */}
      {/* {JSON.stringify(tab)} */}

      <div className="tabs">
        {tabsCount < 1 && (
          <b className="button-label">
            {costType === "C" ? "Add New Condition" : "Add Repair Type"}
          </b>
        )}

        {editing[vendorTempId] && (
          <button className="filled icon mid-size" onClick={handleClick}>
            <i className="icon-add-new small-icon"></i>
          </button>
        )}

        {/* <i>
                    {JSON.stringify(currency)}
                </i> */}
        {/* {JSON.stringify(tab)} */}

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <ConditionsMenu
            addClick={applyClick}
            preSelect={memoVendorConditions}
            conditions={partConditions}
            handleClose={handleClose}
          />
          {/* <ConditionsMenu addClick={applyClick} preSelect={vendorConditions.map(c => costType === "C" ? c.partConditionId : c.repairTypeId)} conditions={partConditions} handleClose={handleClose} /> */}
        </Popover>

        {tabsCount > 3 && (
          <button
            onClick={() => navigate("l")}
            className="filled icon mid-size leftbutton"
            disabled={disabledNav.left}
          >
            <i className="icon-arrow-down chevron-left"></i>
          </button>
        )}

        <div
          className="tabs-container"
          onScroll={handleScroll}
          ref={tabsContainerRef}
        >
          {/* {partConditions.filter(c => c).map(c => */}
          {/* {partConditions.filter(c =>vendorConditions.map(c => c[conditionProp[costType]]).includes(c.id)).map(c => */}
          {vendorConditions.map((v) => {
            let c = idxConditions[v[conditionProp[costType]]];
            return (
              <button
                id={`tab/${vendorTempId}/${c.id}`}
                tabIndex={0}
                onClick={() => selectTab(c)}
                className={`transparent tab ${
                  tab?.id === c.id ? "active" : ""
                }`}
                key={c.name}
              >
                <span>{c.name}</span>

                <div className="delete-btn-container">
                  {typeof v.id === "number" ? (
                    <DialogTrigger
                      dialogContent={{
                        component: DeletePartDialog,
                        props: {
                          item: {},
                          message: `Are you sure you want to delete the ${
                            costType === "C" ? "condition" : "repair type"
                          } "${c.name}" for this vendor?`,
                          onDelete: () => deleteVendorCondition(v.id),
                        },
                      }}
                    >
                      <i className="icon-delete-new"></i>
                    </DialogTrigger>
                  ) : (
                    <i
                      className="icon-delete-new"
                      onClick={(e) => handleDeleteTab(e, c.id)}
                    ></i>
                  )}
                </div>
              </button>
            );
          })}
        </div>

        {tabsCount > 3 && (
          <button
            onClick={() => navigate("r")}
            className="filled icon mid-size"
            disabled={disabledNav.right}
          >
            <i className="icon-arrow-down chevron-right"></i>
          </button>
        )}
      </div>

      <div className="tab-content">
        {loading ? (
          <>
            <Skeleton height="var(--item-min-height)" />
            <Skeleton height="var(--item-min-height)" />
            <Skeleton height="var(--item-min-height)" />
            <Skeleton height="var(--item-min-height)" />
          </>
        ) : (
          <>
            {tabsCount < 1 && !loading && (
              <div className="placeholder-container">
                <b>
                  Add {costType === "C" ? "Conditions" : "Repair Types"} before
                  proceeding.
                </b>
                <span>
                  To continue, you need to add at least one{" "}
                  {costType === "C" ? "condition" : "repair type"}
                  <br></br>
                  using the{" "}
                  {costType === "C"
                    ? "Add New Condition"
                    : "Add Repair Type"}{" "}
                  (+) button
                </span>
              </div>
            )}
            {tabsCount >= 1 && (
              <>
                {vendorConditions.map(
                  (v, j) =>
                    tab.id === v[conditionProp[costType]] && (
                      <VendorTabContent
                        part={part}
                        vendorTempId={vendorTempId}
                        TATInfo={v}
                        conditionIdx={j}
                      />
                    )
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

function scrollToNextElement(container, direction) {
  if (!container || !(container instanceof HTMLElement)) {
    console.error("Invalid container element");
    return;
  }

  const scrollAmount = container.clientWidth; // Assuming full container width per step
  const currentScroll = container.scrollLeft;

  if (direction === "r") {
    container.scrollTo({
      left: currentScroll + scrollAmount,
      behavior: "smooth",
    });
  } else if (direction === "l") {
    container.scrollTo({
      left: currentScroll - scrollAmount,
      behavior: "smooth",
    });
  } else {
    console.error("Invalid direction. Use 'l' for left or 'r' for right.");
  }
}
